export default __webpack_public_path__ + "dad951fdedc1f594d283a13fff947cbf.png";